import React, { useEffect, useRef, useState, createRef } from "react";
import {
  Col,
  Row,
  Form,
  DatePicker,
  Button,
  Space,
  Tooltip,
  Menu,
  Checkbox,
  Input,
  Dropdown,
  Table,
} from "antd";

import { getRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { t } from "i18next";

import { authUserData } from "../../utils/Helper";

import SearchIcon from "../../image/SearchIcon.svg";
import moment from "moment";

import {
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
} from "@ant-design/icons";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { createRoot } from "react-dom/client";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { debounce } from "lodash";

import InvoicePdf from "../invoice/InvoicePdf";
import RechargeInvoicePdf from "../invoice/RechargeInvoicePdf";
import AdjustmentInvoicePdf from "../invoice/AdjustmentInvoicePdf";
function TransactionListCompany() {
  const CompanyType = authUserData()?.company_type
    ? authUserData()?.company_type
    : "";

  const [form] = Form.useForm();
  const [driverForm] = Form.useForm();

  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [totalCount, settotalCount] = useState(0);

  useEffect(() => {
    window.dispatchEvent(new Event("resize"));
  }, []);

  const intialFilter = {
    created_at: "",
    transaction_type: "",
  };

  const [loading, setLoading] = useState(false);
  const [stateFilter, setStateFilter] = useState(intialFilter);

  const [startDate, setStartDate] = useState(null);
  const formRef = useRef();

  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  // route list

  const getEmployeeList = async () => {
    setLoading(true);

    try {
      let apiResponse = await getRequest(
        `wallet-transaction/login-company-transactions/?transaction_type=${
          CompanyType === "Pre Paid" ? "recharge" : "payment"
        }&created_at=${stateFilter?.created_at}`,
        state
      );
      // let apiResponse = await getRequest(
      //   `wallet-transaction/login-company-transactions/?transaction_type=${stateFilter?.transaction_type}&created_at=${stateFilter?.created_at}`,
      //   state
      // );

      if (apiResponse?.data?.results?.success) {
        setEmployeeList(apiResponse?.data?.results?.data);
        settotalCount(apiResponse.data.count);
        setLoading(false);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching transaction list"));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getEmployeeList();
  }, [state, t]);

  const [checkedList, setCheckedList] = useState([
    "created_at",
    "transaction_type",
    "amount",
    "note",

    "operation",
  ]);

  const [columns, setColumns] = useState([]);
  const allColumns = [
    { key: "created_at", title: "Date" },
    { key: "transaction_type", title: "Type" },
    { key: "amount", title: "Amount" },
    { key: "note", title: "Note" },

    { key: "operation", title: "Action" },
  ];

  useEffect(() => {
    const updatedColumns = [
      {
        title: "Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
      },
      {
        title: "Type",
        dataIndex: "transaction_type",
        key: "transaction_type",
        width: 180,
        sorter: true,
        render: (_, record) => {
          switch (record?.transaction_type) {
            case "recharge_initiated":
              return "Recharge Initiated";
            case "payment_initiated":
              return "Payment Initiated";
            case "pickup_charge":
              return "Pickup Charge";
            default:
              return record?.transaction_type;
          }
        },
      },
      {
        title: "Amount",
        dataIndex: "amount",
        key: "amount",
        sorter: true,
        render: (amount) => `$${amount}`,
      },
      {
        title: "Note",
        dataIndex: "note",
        key: "note",
        sorter: true,
      },

      {
        title: "Action",
        key: "operation",
        sorter: false,
        fixed: "right",
        width: 80,

        render: (text, record) =>
          record?.transaction_type === "recharge" ||
          record?.transaction_type === "payment" ? (
            <Tooltip title="Download Invoice">
              <span
                className="material-symbols-outlined"
                onClick={() =>
                  handleDownload(
                    record?.id,
                    record?.company_id,
                    record?.company_type
                  )
                }
                style={{ cursor: "pointer" }}
              >
                download
              </span>
            </Tooltip>
          ) : (
            ""
          ),
      },
    ].filter((column) => checkedList.includes(column.key));

    setColumns(updatedColumns);
  }, [checkedList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );
  const handleDownload = async (transactionId, companyId, company_type) => {
    try {
      let apiResponse = await getRequest(
        `wallet-transaction/invoice-by-transaction/?transaction_id=${transactionId}&company_id=${companyId}`
      );
      console.log("apiResponse", apiResponse);
      const data = apiResponse.data.invoice;
      const { recharge_amount, total_amount_with_gst, adjustment_amount } =
        data;
      const tempContainer = document.createElement("div");
      document.body.appendChild(tempContainer);

      const invoiceRef = createRef();
      if (data) {
        const root = createRoot(tempContainer);
        if (
          company_type === "Pre Paid" &&
          recharge_amount &&
          parseFloat(recharge_amount) > 0
        ) {
          root.render(<RechargeInvoicePdf ref={invoiceRef} data={data} />);
        } else if (
          company_type === "Post Paid" &&
          total_amount_with_gst &&
          parseFloat(total_amount_with_gst) > 0
        ) {
          root.render(<InvoicePdf ref={invoiceRef} data={data} />);
        } else if (adjustment_amount && parseFloat(adjustment_amount) > 0) {
          root.render(<AdjustmentInvoicePdf ref={invoiceRef} data={data} />);
        } else {
          // Fallback for no valid amount found
          console.warn("No valid amount found to generate invoice PDF.");
        }
        // Wait for the component to render
        setTimeout(async () => {
          const canvas = await html2canvas(invoiceRef.current);
          const imgData = canvas.toDataURL("image/png");
          const pdf = new jsPDF("p", "mm", "a4");
          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

          pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
          pdf.save(`invoice_${data.invoice_number}.pdf`);

          root.unmount();
          document.body.removeChild(tempContainer);
        }, 1000); // small delay to ensure DOM render
      } else {
        ErrorNotificationMsg("Record does not has invoice data");
      }
    } catch (error) {
      console.error("Error downloading invoice:", error);
      ErrorNotificationMsg("Error downloading invoice");
    }
  };
  // const handleResidentSelectChange = (value) => {
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     transaction_type: value,
  //   }));
  // };
  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = moment(date).format("DD-MM-YYYY");
      // setStartDate(formattedDate);
      setStateFilter((prevState) => ({
        ...prevState,
        created_at: formattedDate,
      }));
    } else {
      // When date is cleared
      setStateFilter((prevState) => ({
        ...prevState,
        created_at: null,
      }));
    }
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields();
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "created_at" && sortOrder === "ascend")
      sortingEnumKey = "created_at";
    if (sortField === "created_at" && sortOrder === "descend")
      sortingEnumKey = "-created_at";
    if (sortField === "transaction_type" && sortOrder === "ascend")
      sortingEnumKey = "transaction_type";
    if (sortField === "transaction_type" && sortOrder === "descend")
      sortingEnumKey = "-transaction_type";
    if (sortField === "amount" && sortOrder === "ascend")
      sortingEnumKey = "amount";
    if (sortField === "amount" && sortOrder === "descend")
      sortingEnumKey = "-amount";
    if (sortField === "note" && sortOrder === "ascend") sortingEnumKey = "note";
    if (sortField === "note" && sortOrder === "descend")
      sortingEnumKey = "-note";

    return sortingEnumKey;
  };

  const handleResetGrid = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };
  const handleApplyFilter = async () => {
    setState({
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
  };

  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "id",
      pagesize: 10,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);

    form.setFieldsValue({ search: "" });
    setStartDate(null);

    formRef.current.setFieldsValue({
      created_at: undefined,
      transaction_type: undefined,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {
  //     setSelectedRow(selectedRowKeys);

  //     if (selectedRowKeys.length === 0) {
  //       driverForm.resetFields();
  //     }
  //   },
  //   onSelect: (record, selected, selectedRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, record.id]
  //       : selectedRow?.filter((key) => key !== record.id);
  //     setSelectedRow(updatedSelectedRowKeys);

  //     if (updatedSelectedRowKeys?.length === 0) {
  //       driverForm.resetFields();
  //     }
  //   },
  //   onSelectAll: (selected, selectedRows, changeRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, ...changeRows.map((row) => row.id)]
  //       : selectedRow?.filter(
  //           (key) => !changeRows.find((row) => row.id === key)
  //         );
  //     setSelectedRow(updatedSelectedRowKeys);

  //     if (updatedSelectedRowKeys?.length === 0) {
  //       driverForm.resetFields();
  //     }
  //   },
  //   selectedRowKeys: selectedRow,
  // };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("Transaction List")}</h3>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleResetGrid()}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}

            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
          </Space>
        </div>
      </div>

      <div className="Package-body">
        <div className="filterrow packagefilter">
          <div className="filtercol">
            <Form autoComplete="off" ref={formRef}>
              <Space wrap>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="TextFeild gutter-row"
                >
                  <Form.Item name="created_at" label={t("Schedule Date")}>
                    <DatePicker
                      format="DD-MM-YYYY"
                      placeholder="Select Date"
                      //showTime={true}
                      // onChange={(date, dateString) =>
                      //   handleMinDateChange(date, dateString)
                      // }
                      value={startDate ? moment(startDate, "DD-MM-YYYY") : null}
                      allowClear={true}
                      style={{ width: "140px" }}
                      // value={startDate}
                      onChange={handleStartDateChange}
                    />
                  </Form.Item>
                </Col>

                {/* <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  className="TextFeild gutter-row"
                >
                  <Form.Item
                    name="transaction_type"
                    label={t("Transaction Type")}
                    value={state?.transaction_type}
                  >
                    <Select
                      showArrow
                      placeholder={t("Select Type")}
                      onChange={(value) => handleResidentSelectChange(value)}
                    >
                      <Option key="pickup_charge" value="pickup_charge">
                        Pickup Charge
                      </Option>
                      <Option key="recharge" value="recharge">
                        Recharge
                      </Option>
                      <Option key="payment" value="payment">
                        Payment
                      </Option>
                      <Option key="adjustment" value="adjustment">
                        Adjustment
                      </Option>
                      <Option
                        key="recharge_initiated"
                        value="recharge_initiated"
                      >
                        Recharge Initiated
                      </Option>
                    </Select>
                  </Form.Item>
                </Col> */}
              </Space>
            </Form>
          </div>
          <div className="btnscol btncolpack">
            <Space className="btnpack">
              <>
                {/* <Tooltip title="Apply Filter"> */}
                <span>
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    label={
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                      >
                        <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                        Filter
                      </span>
                    }
                    onClick={handleApplyFilter}
                  />
                </span>
                {/* </Tooltip> */}
                {startDate ||
                stateFilter?.created_at ||
                stateFilter?.transaction_type ? (
                  // <Tooltip title="Reset Filter">
                  <span>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Reset"
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <UndoOutlined
                            style={{
                              fontSize: "16px",
                              color: "#fff",
                            }}
                          />{" "}
                          Reset
                        </span>
                      }
                      onClick={handleResetFilter}
                    />
                  </span>
                ) : (
                  // </Tooltip>
                  ""
                )}
              </>
              {/* ) : (
                  ""
                )} */}
            </Space>
          </div>
        </div>

        <Table
          // rowSelection={rowSelection}
          rowKey={(record) => record.id}
          columns={columns.filter((col) => !col.hidden)}
          dataSource={employeeList}
          loading={loading}
          pagination={{
            defaultCurrent: state.page,
            defaultPageSize: state.pagesize,
            total: totalCount,
            showTotal: (total) => `Total ${total} items`,
            showSizeChanger: true,
            locale: {
              items_per_page: "Items / Page",
            },
          }}
          onChange={handleTableChange}
        />
      </div>
    </>
  );
}

export default TransactionListCompany;
